import { DOCUMENT } from '@angular/common';
import {
    Component,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    Input,
    ElementRef,
    Optional,
    Inject,
    HostBinding,
} from '@angular/core';
import type { iccIcon } from '../../icons';
import { IconRegistryService } from './icon-registry.service';

@Component({
    selector: 'icc-icon',
    template: `<ng-content></ng-content>`,
    styleUrls: ['./icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
    private svgIcon!: SVGElement;
    private iconName!: iccIcon;

    /** Menu item class */
    @HostBinding('class') class = 'icc-icon notranslate';

    @Input()
    set name(iconName: iccIcon) {
        if (this.iconName === iconName) {
            return;
        }
        if (this.svgIcon) {
            this.element.nativeElement.removeChild(this.svgIcon);
        }
        this.iconName = iconName;
        const svgElement = this.iconRegistry.getIconElement(iconName, this.document);
        if (svgElement) {
            this.svgIcon = svgElement;
            this.element.nativeElement.appendChild(this.svgIcon);
        }
    }

    constructor(
        private element: ElementRef,
        private iconRegistry: IconRegistryService,
        @Optional() @Inject(DOCUMENT) private document: Document
    ) {}


}
